/** BizAI mascot — visual identity for the AI Agents module. */
export const BIZAI_MASCOT_SRC = 'images/bizai-mascot.png';
